query editMarketList($sportId: UUID!) {
  marketGroups: allMarketGroups(
    orderBy: POSITION_ASC
    condition: { sportId: $sportId }
  ) {
    nodes {
      code
      displayName
      markets: marketGroupMarketCodesByMarketGroupId {
        nodes {
          marketCode
        }
      }
    }
  }
  marketTemplates: allMarketTemplates(condition: { sportId: $sportId }) {
    nodes {
      marketTemplateId
      template
    }
  }
}
